import { createTechnicalBase } from './shared/technicalBase'

const base = createTechnicalBase()

export default {
    namespaced: true,
    state() {
        return {
            ...base.state(),
            brigadeData: {
                polylineBrigade: [],
                markerBrigade: []
            },
            active: true,
            isGps: false,

            // tree-check-technical
            aSelectTech: [],
        }
    },
    getters: {
        ...base.getters,
        getBrigadeData(state) {
            return state.brigadeData
        },
        getActive(state) {
            return state.active
        },
        getIsGps(state) {
            return state.isGps
        },
        getSelectTech(state){
            return state.aSelectTech;
        }
    },
    mutations: {
        ...base.mutations,
        SET_BRIGADE_DATA(state, item) {
            state.brigadeData = {
                polylineBrigade: item.polylineBrigade,
                markerBrigade: item.markerBrigade
            }
        },
        CLEAR_BRIGADE_DATA(state) {
            state.brigadeData = {
                polylineBrigade: [],
                markerBrigade: []
            }
        },
        SWITCH_ACTIVE(state, val) {
            state.active = val;
        },
        SWITCH_GPS(state, val) {
            state.isGps = val;
        },
        ADD_SELECT_TECH(state, tech){
            const isExistTech = state.aSelectTech.find((el)=> el === tech);
            if (!isExistTech) {
                state.aSelectTech = [...state.aSelectTech, tech];
            }
        },
        REMOVE_SELECT_TECH(state, tech){
            state.aSelectTech = state.aSelectTech.filter((el)=>el!== tech);
        }
    },
    actions: {
        ...base.actions,
        setIsGps({ commit }, value) {
            commit('SWITCH_GPS', value)
        },
        setBrigadeData({ commit }, state) {
            commit('SET_BRIGADE_DATA', state)
        },
        clearBrigadeData({ commit }) {
            commit('CLEAR_BRIGADE_DATA')
        },
        setActive({ commit }, state) {
            commit('SWITCH_ACTIVE', state)
        },
        addNewSelectTech({commit}, tech){
            commit("ADD_SELECT_TECH", tech)
        },
        removeSelectTech({commit},tech){
            commit("REMOVE_SELECT_TECH", tech)
        }
    }
}
